export default __webpack_public_path__ + "static/media/ci-reward-frequent.fc4edd2d.svg";